import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["zh", "jp"],
    lng: "jp",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["common", "option"],
    defaultNS: "common",
    fallbackLng: ["en", "de", "zh", "jp"],
    returnedObjectHandler(key, value, options) {
      return JSON.stringify(value);
    },
  });

export default i18n;
